<template>
  <JoszakiAutocomplete
    :value="value"
    v-bind="$attrs"
    :placeholder="placeholder ?? $t('professionTaskAutocomplete.placeholder')"
    :items="items"
    @input="$emit('input', $event)"
    @search="onSearch"
    @focus="onFocus"
    v-on="$listeners"
  >
    <template #empty>
      <span>
        {{ $t("professionTaskAutocomplete.empty") }}
      </span>
    </template>
  </JoszakiAutocomplete>
</template>

<script>
import { ref, watch } from "@nuxtjs/composition-api";
import { useProfessionTaskQueries } from "~/composables/useProfessionTaskQueries";

export default {
  props: {
    value: {
      type: [Object, Array],
      default: () => null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    professionId: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const { fetchProfessionTasks } = useProfessionTaskQueries();

    const searchValue = ref("");
    const items = ref([]);

    const onSearch = async (search) => {
      searchValue.value = search;
      const filters = {
        search,
      };

      if (props.professionId) {
        filters.professionIds = [props.professionId];
      }
      items.value = await fetchProfessionTasks(filters);
    };

    const onFocus = () => {
      onSearch("");
      emit("focus");
    };

    watch(
      () => props.professionId,
      async () => {
        await onSearch(searchValue.value);
      }
    );

    return {
      items,
      onFocus,
      onSearch,
    };
  },
};

/** TODO : check usage */
</script>
